import React from "react";
import { SellerQuotesListPage } from "../../SharedPages/SellerQuotesListPage/SellerQuotesListPage";

/**
 * The "Quotes" page that displays a list of quote requests.
 */
export const SellerQuotesList = () => {
  return <SellerQuotesListPage />;
};
